import { Notifications } from "@mantine/notifications";
import { ComponentProps } from "react";

export const NOTIFICATION_SETTINGS: ComponentProps<typeof Notifications> = {
  limit: 3,
  position: "top-right"
};
